export default __webpack_public_path__ + "static/35-cfd4f05da74eb6499f07877ab34ec4f9.png";